import React from 'react';
import { useSnackbar } from 'notistack';
import * as fileApi from '../../../lib/api/file';
import { useDispatch } from 'react-redux';
import { tempSetUser } from '../../../modules/auth';
import ProfileUpload from '../../../components/common/fileupload/ProfileUpload';

const ProfileUploadContainer = ({fileTyp, fileAttrVal1}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const uploadProfileImage = async (file) => {
    let formData = new FormData();
    formData.append('fileDt', file);
    formData.append('fileTyp', fileTyp);
    formData.append('fileAttrVal1', fileAttrVal1);

    try {
      const res = await fileApi.uploadProfile(formData);
      if (res.data.info) {
        dispatch(tempSetUser(res.data.info));
        localStorage.setItem('user', JSON.stringify(res.data.info));
        enqueueSnackbar('프로필 이미지 변경 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return <ProfileUpload uploadProfileImage={uploadProfileImage} />;
};

export default ProfileUploadContainer;
